import Vue from "vue";
import VueAnalytics from "vue-analytics";
import VueMeta from 'vue-meta'
import { ValidationProvider } from 'vee-validate/dist/vee-validate.full.esm';
import { ValidationObserver } from 'vee-validate';
import App from "./App.vue";

Vue.component('ValidationProvider', ValidationProvider);
Vue.component('ValidationObserver', ValidationObserver);

export const bus = new Vue();

//Vue meta data
Vue.use(VueMeta,{
  keyName: 'head'
})

// Configuration VueAnalytics
Vue.use(VueAnalytics, {
  id: process.env.VUE_APP_GA_TRACKING_CODE,
});

new Vue({
  render: (h) => h(App),
}).$mount("#app");
